// src/services/logProtocolsService.js

const API_BASE_URL = process.env.REACT_APP_API_ADDRESS;

const getAuthHeaders = () => ({
    'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
});

/**
 * Get list of current user's log protocols
 */
export const getLogProtocols = async (page = 1) => {
    const url = new URL(`${API_BASE_URL}/logs-and-protocols/log-protocols/`);
    if (page) url.searchParams.append('page', page);

    const response = await fetch(url.toString(), {
        method: 'GET',
        headers: getAuthHeaders(),
    });

    if (!response.ok) {
        throw new Error(`Failed to load protocols (status ${response.status})`);
    }

    return await response.json();
};

/**
 * Get detailed protocol info
 */
export const getLogProtocolDetail = async (id) => {
    const response = await fetch(`${API_BASE_URL}/logs-and-protocols/log-protocols/${id}/`, {
        method: 'GET',
        headers: getAuthHeaders(),
    });

    if (!response.ok) {
        throw new Error(`Failed to load protocol detail (status ${response.status})`);
    }

    return await response.json();
};

/**
 * 1. FOR THE DOWNLOAD BUTTON
 * Fetches the PDF and forces a hard-drive download
 */
export const downloadLogProtocolPDF = async (id) => {
    const response = await fetch(`${API_BASE_URL}/logs-and-protocols/log-protocols/${id}/pdf/`, {
        method: 'GET',
        headers: getAuthHeaders(),
    });

    if (!response.ok) {
        throw new Error(`Failed to download PDF (status ${response.status})`);
    }

    // Turn response into a Blob
    const blob = await response.blob();

    // Create a blob URL & trigger download
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `protocol_${id}.pdf`;

    document.body.appendChild(link);
    link.click();
    link.remove();

    // free memory
    window.URL.revokeObjectURL(url);
};

/**
 * 2. FOR THE PREVIEW (EYE ICON)
 * Fetches the PDF into memory for the iframe using ?inline=true
 */
export const getLogProtocolPdfBlob = async (id) => {
    // Note the ?inline=true added to the URL here
    const response = await fetch(`${API_BASE_URL}/logs-and-protocols/log-protocols/${id}/pdf/?inline=true`, {
        method: 'GET',
        headers: getAuthHeaders(),
    });

    if (!response.ok) {
        throw new Error(`Failed to fetch PDF for preview (status ${response.status})`);
    }

    // Just return the raw blob directly to the component. 
    // NO <a> tag, NO forced download.
    return await response.blob();
};